import React, { useContext, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';
import * as querystring from 'querystring';
import { EnrollmentContext } from '../../providers/EnrollmentContextProvider';
import { TriptychLayout } from '../../components/layout/TriptychLayout';
import EnrollmentProgress from './components/EnrollmentProgress';
import ExitButton from './components/ExitButton';
import enrollmentAction from '../../providers/EnrollmentContextProvider/enrollmentAction';
import './styles.less';

const EnrollmentPage = () => {
  const { currentStep, isStepExpanded, currentStepIndex, isStepShrunken, dispatch } = useContext(
    EnrollmentContext
  );
  const history = useHistory();
  const location = useLocation();

  const CurrentStepComponent = currentStep.Component;

  useEffect(() => {
    const { stepIndex: stepIndexQuery } = querystring.parse(location.search.substring(1));
    const stepIndex = Number(stepIndexQuery) || 0;

    if (stepIndex !== currentStepIndex) {
      dispatch({
        type: enrollmentAction.SET_STEP_INDEX,
        payload: stepIndex,
      });

      setTimeout(() => window.scrollTo(0, 0), 1);
    }
  }, [currentStepIndex, location.search, dispatch]);

  useEffect(() => {
    history.replace(`/enrolamiento/formulario?stepIndex=0`);
  }, [history]);

  const goToNextStep = () => {
    history.push(`/enrolamiento/formulario?stepIndex=${currentStepIndex + 1}`);
  };

  const goToPrevStep = () => {
    history.push(`/enrolamiento/formulario?stepIndex=${currentStepIndex - 1}`);
  };

  let hideAppend = currentStep.usesTwoColumns;
  if (isStepShrunken) {
    hideAppend = false;
  } else if (isStepExpanded) {
    hideAppend = true;
  }

  return (
    <TriptychLayout noAppendPadding hideAppend={hideAppend}>
      <EnrollmentProgress onBack={goToPrevStep} />
      <Fade key={currentStepIndex}>
        <CurrentStepComponent onFinish={goToNextStep} />
      </Fade>
      <div className="enrollment__background" />
      <ExitButton />
    </TriptychLayout>
  );
};

export default EnrollmentPage;
